import React, { useEffect, useState } from 'react';
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel, IonButton, IonInput, IonFooter } from '@ionic/react';
import { useArtStore } from '../stateManagement/artZustand';
import { useURLStore } from '../stateManagement/URLZustand';
import { _defaultButtonColor, _dict } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface SavedArtComponentProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (layoutName: string) => void;
}

interface ArtItem {
  name: string; // Removed the id property since we'll use name as the unique identifier
}

const SavedArtComponent: React.FC<SavedArtComponentProps> = ({ isOpen, onClose, onConfirm}) => {
  const [ artItems, setArtItems ] = useState<ArtItem[]>([]);
  const [ selectedItemName, setSelectedItemName ] = useState<string | null>(null); // Changed from selectedItemId to selectedItemName
  const { URLVars } = useURLStore();
  const { path2art, removeAllItemsFromPath } = useArtStore();
  const { lang } = useGlobalStore();


  const handleSelectItem = (name: string) => {
    setSelectedItemName((prevSelectedName) => (prevSelectedName === name ? null : name));
  };

  const handleRemoveItem = () => {
    if (selectedItemName === null) return;
    setArtItems((prevItems) => prevItems.filter(item => item.name !== selectedItemName));
    setSelectedItemName(null); // Clear selection after removal

    // Remove from path2art too
    removeAllItemsFromPath(URLVars.nodePath!, selectedItemName);
  };

  const handleLoadItem = () => {
    const selectedItem = artItems.find(item => item.name === selectedItemName);
    if (selectedItem) {
      // Load the selected item
      onConfirm(selectedItem.name);
    }
  };

  useEffect(() => {
    // Load saved art items from path2art
    const savedItems = Object.keys(path2art[URLVars.nodePath!]).map((key) => ({ name: key }));
    setArtItems(savedItems);
  }, [path2art, URLVars.nodePath]);

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{_dict.storedLayoutsList[lang]}</IonTitle>
          <IonButton slot="end" onClick={onClose} color="danger">{_dict.close[lang]}</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList >
          {artItems.map((item, index) => ( // Use index as key since names are unique but react needs a key
            <IonItem key={index} button onClick={() => handleSelectItem(item.name)}
            color={selectedItemName === item.name ? _defaultButtonColor : undefined}
            style={{backgroundColor: selectedItemName === item.name ? _defaultButtonColor : undefined,
            color: selectedItemName === item.name ? 'white' : undefined}}
            lines='none'
            >
              <IonLabel>{item.name}</IonLabel>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
      <IonFooter>
        <IonToolbar>
        {selectedItemName && (
          <>
            <IonButton style={{backgroundColor:_defaultButtonColor}} color={_defaultButtonColor} expand="full" onClick={handleLoadItem}>{_dict.load[lang]}</IonButton>
            <IonButton expand="full" color="danger" onClick={handleRemoveItem}>{_dict.removeSelectedItems[lang]}</IonButton>
          </>
        )}
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};

export default SavedArtComponent;
